export default __webpack_public_path__ + "6f3caf171501237227082af785858fbb.svg";